import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogContent, DialogTitle, Icon } from '@mui/material';
import { PaperArrastavel } from '../../dialog-arrastavel/PaperArrastavel';
import { IColuna } from 'app/types/IColuna';
import clsx from 'clsx';
import React, { useState, useCallback, memo } from 'react';
import { TraduzirNomeColunaPesquisaOrcamento } from './TraduzirNomeColunaPesquisaOrcamento';

export type AcoesHeadPesquisaOrcamentoProps = {
    onAlterarFonte?: (tamanho: number) => void;
    colunas: IColuna[];
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
    tamanhoFonte: number;
    exibirIconesAumentarDiminuirFonte?: boolean;
    larguraLinha?: number;
    permiteEngrenagemGrid?: boolean;
};

const SelecaoDeColunas = memo(({ colunas, onToggleColunaSelecionada, onToggleSelecionarTodasColunas }: {
    colunas: IColuna[];
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void;
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void;
}) => (
    <div className="_grid _grid-cols-1 _grid-flow-row">
        <div className="_flex _flex-row _justify-start _max-w-xs _items-end">
            <div className="_mr-4">
                <input
                    type="checkbox"
                    checked={colunas.every(c => c.Selecionada)}
                    onChange={e => onToggleSelecionarTodasColunas(e.target.checked)}
                />
            </div>
            <b>Todas</b>
        </div>
        {colunas.map(coluna => (
            <div className="_flex _flex-row _justify-start _max-w-xs _items-end" key={coluna.Nome}>
                <div className="_mr-4">
                    <input
                        type="checkbox"
                        checked={coluna.Selecionada ?? false}
                        onChange={() => onToggleColunaSelecionada(coluna.Nome, !coluna.Selecionada)}
                    />
                </div>
                {TraduzirNomeColunaPesquisaOrcamento({ nomeColuna: coluna.Nome })}
            </div>
        ))}
    </div>
));

const Botoes = memo(({ onAlterarFonte, tamanhoFonte, exibirIconesAumentarDiminuirFonte, larguraLinha, permiteEngrenagemGrid, setExibirSelecaoDeColunas }: {
    onAlterarFonte?: (tamanho: number) => void;
    tamanhoFonte: number;
    exibirIconesAumentarDiminuirFonte?: boolean;
    larguraLinha?: number;
    permiteEngrenagemGrid?: boolean;
    setExibirSelecaoDeColunas: (value: boolean) => void;
}) => (
    <div style={{ width: larguraLinha != undefined ? `${larguraLinha}px` : undefined }} className="_flex _flex-row _mt-4 _gap-x-2 _bg-[#daddde] _p-2">
        {(permiteEngrenagemGrid ?? false) && (
            <FontAwesomeIcon icon={faGear} className="_text-2xl _cursor-pointer" onClick={() => setExibirSelecaoDeColunas(true)} />
        )}
        {(exibirIconesAumentarDiminuirFonte ?? true) && (
            <>
                <button
                    className="no-global-button _bg-white _p-2 _rounded-md"
                    onClick={() => onAlterarFonte?.(tamanhoFonte + 1)}
                    disabled={tamanhoFonte >= 26}
                >
                    A+
                </button>
                <button
                    className="no-global-button _bg-white _p-2 _rounded-md"
                    onClick={() => onAlterarFonte?.(tamanhoFonte - 1)}
                    disabled={tamanhoFonte <= 8}
                >
                    A-
                </button>
            </>
        )}
    </div>
));

const IconeExibirEsconderOpcoes = memo(({ mostrarFerramentas, setMostrarFerramentas, setIcon, icon }: {
    mostrarFerramentas: boolean;
    setMostrarFerramentas: (value: boolean) => void;
    setIcon: (value: string) => void;
    icon: string;
}) => (
    <button
        style={{ marginLeft: '14px', height: '20px' }}
        id="table-headgrid-itensarrow"
        className="no-global-button"
        onClick={() => {
            setMostrarFerramentas(!mostrarFerramentas);
            setIcon(icon === "arrow_drop_up" ? "arrow_drop_down" : "arrow_drop_up");
        }}
    >
        <Icon>{icon}</Icon>
    </button>
));

export const AcoesHeadPesquisaOrcamento = (props: AcoesHeadPesquisaOrcamentoProps) => {
    const [mostrarFerramentas, setMostrarFerramentas] = useState<boolean>(false);
    const [icon, setIcon] = useState<string>('arrow_drop_up');
    const [exibirSelecaoColunas, setExibirSelecaoDeColunas] = useState(false);

    const handleToggleSelecionarTodasColunas = useCallback((selecionar: boolean) => {
        props.onToggleSelecionarTodasColunas(selecionar);
    }, [props.onToggleSelecionarTodasColunas]);

    const handleToggleColunaSelecionada = useCallback((nomeColuna: string, selecionada: boolean) => {
        props.onToggleColunaSelecionada(nomeColuna, selecionada);
    }, [props.onToggleColunaSelecionada]);

    return (
        <div className="_flex _flex-col _bg-[#daddde] _items-start">
            <IconeExibirEsconderOpcoes
                mostrarFerramentas={mostrarFerramentas}
                setMostrarFerramentas={setMostrarFerramentas}
                setIcon={setIcon}
                icon={icon}
            />
            {mostrarFerramentas && (
                <section>
                    <Botoes
                        onAlterarFonte={props.onAlterarFonte}
                        tamanhoFonte={props.tamanhoFonte}
                        exibirIconesAumentarDiminuirFonte={props.exibirIconesAumentarDiminuirFonte}
                        larguraLinha={props.larguraLinha}
                        permiteEngrenagemGrid={props.permiteEngrenagemGrid}
                        setExibirSelecaoDeColunas={setExibirSelecaoDeColunas}
                    />
                </section>
            )}
            {exibirSelecaoColunas && (
                <Dialog 
					open={exibirSelecaoColunas} 
					onClose={() => setExibirSelecaoDeColunas(false)} 
					PaperComponent={PaperArrastavel}
				>
                    <DialogTitle>Selecionar colunas para exibição</DialogTitle>
                    <DialogContent>
                        <SelecaoDeColunas
                            colunas={props.colunas}
                            onToggleColunaSelecionada={handleToggleColunaSelecionada}
                            onToggleSelecionarTodasColunas={handleToggleSelecionarTodasColunas}
                        />
                    </DialogContent>
                </Dialog>
            )}
        </div>
    );
};